import { comments } from "@/mocks/homeData";

export default function CommentsSection() {
  return (
    <section id="comments" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            用户评价
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            来自追剧爱好者的真实反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${
                      i < item.rating
                        ? "ri-star-fill text-primary-400"
                        : "ri-star-line text-foreground-300"
                    }`}
                  />
                ))}
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed flex-1">
                &ldquo;{item.content}&rdquo;
              </p>

              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500 whitespace-nowrap">
                    {item.date}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}